import { object, string, bool } from "yup";
import type { InferType } from "yup";

import { eventVersion } from "./events";

export const schema = object({
  event_type: string().required(),
  event_version: string().required().oneOf(eventVersion),
  isTestEvent: bool(),
  meta: object({
    user_id: string(),
    session_id: string(),
    page_load_id: string(),
    product_version: string(),
    client_id: string(),
    product_name: string().required(),
  }),
  attributes: object({}),
});

export type Params = InferType<typeof schema>;
